export const qkBaseAutocomplete = ['autocomplete']

//listAutocompleteClients
export const qkAutocompleteClients = (filter?: string, searchValue?: string) => [
  ...qkBaseAutocomplete,
  'clients',
  filter?.toUpperCase(),
  searchValue,
]

//listAutocompleteDebtors
export const qkAutocompleteDebtors = (filter?: string | undefined, searchValue?: string) => [
  ...qkBaseAutocomplete,
  'debtors',
  filter?.toUpperCase(),
  searchValue,
]

export const qkAutocompleteInvoiceDebtors = (filter?: string | undefined, searchValue?: string) => [
  ...qkBaseAutocomplete,
  'invoiceDebtors',
  filter?.toUpperCase(),
  searchValue,
]

//listAutocomplete
export const qkAutocomplete = (
  type?: string,
  searchValue?: string,
  clientId?: string,
  excludeCompanyId?: string,
  excludeEmployeeType?: string
) => [...qkBaseAutocomplete, type, searchValue, clientId, excludeCompanyId, excludeEmployeeType]

//ListAutocompleteClientOrBrokerDebtors
export const qkAutocompleteClientOrBrokerDebtors = (searchValue?: string, clientOrBrokerId?: string) => [
  ...qkBaseAutocomplete,
  'clientOrBrokerDebtors',
  searchValue,
  clientOrBrokerId,
]

export const qkAutocompleteInvoices = (searchValue?: string, clientOrBrokerId?: string, invoiceStatus?: string) => [
  ...qkBaseAutocomplete,
  'invoices',
  searchValue,
  clientOrBrokerId,
  invoiceStatus,
]

//listAutocompleteTerms
export const qkAutocompleteTerms = () => [...qkBaseAutocomplete, 'terms']

//listAutocompleteTimezone
export const qkAutocompleteTimezone = (searchValue?: string) => [...qkBaseAutocomplete, 'timezones', searchValue]

//listAutocompleteUsers
export const qkAutocompleteUsers = (accountExecutive?: boolean, collectionAgent?: boolean) => [
  ...qkBaseAutocomplete,
  'users',
  accountExecutive,
  collectionAgent,
]

//listAutocompleteClientsBrokers
export const qkAutocompleteClientsBrokers = (filter?: string, searchValue?: string, accountExecutive?: string) => [
  ...qkBaseAutocomplete,
  'clientsBrokers',
  filter?.toUpperCase(),
  searchValue,
  accountExecutive,
]

export const qkAutocompleteInvoiceClientsBrokers = (
  filter?: string,
  searchValue?: string,
  accountExecutive?: string
) => [...qkBaseAutocomplete, 'invoiceClientsBrokers', filter?.toUpperCase(), searchValue, accountExecutive]

//ListAutocompleteQuickPayFee
export const qkAutocompleteQuickPayFee = (companyClientOrBrokerId?: string) => [
  ...qkBaseAutocomplete,
  'quickPayFee',
  companyClientOrBrokerId,
]

type ListAutocompleteRolesParams = {
  searchValue?: string
  isCompanyRole?: boolean
}

//listAutocompleteRoles
export const qkAutocompleteRoles = (params: ListAutocompleteRolesParams) => [
  ...qkBaseAutocomplete,
  'roles',
  params.searchValue,
  params.isCompanyRole,
]

type ListAutocompleteSalesExecutiveParams = {
  q?: string
}

export const qkAutocompleteSalesExecutive = (params: ListAutocompleteSalesExecutiveParams) => [
  ...qkBaseAutocomplete,
  'salesExecutive',
  params.q,
]

type ListAutocompleteFipsStateCodeParams = {
  q?: string
  stateCode?: string
}
export const qkAutocompleteFipsStateCode = (params: ListAutocompleteFipsStateCodeParams) => [
  ...qkBaseAutocomplete,
  'fipsStateCode',
  params.q,
]

export const qkAutocompleteFipsCountyCode = (stateCode: string, params: ListAutocompleteFipsStateCodeParams) => [
  ...qkBaseAutocomplete,
  'fipsCountyCode',
  stateCode,
  params.q,
]

export const qkAutocompleteAccountExecutive = (params: ListAutocompleteSalesExecutiveParams) => [
  ...qkBaseAutocomplete,
  'accountExecutive',
  params.q,
]

export const qkAutocompleteCommissionPartners = (q?: string) => [...qkBaseAutocomplete, 'commissionPartners', q]

export const qkAutocompleteCommissionTemplates = (q?: string) => [...qkBaseAutocomplete, 'commissionTemplates', q]
